import React, { useState } from 'react'
import NuDateFormat from '../../../utils/NuDate';
import FileDisplay from '../../../utils/FileDisplay';
import { CloseIcon } from '../../../assets/icons';

function ViewVendor({visible, onClose, data}) {

    if (!visible) return null;
  return (
    <div
    id="modal"
    className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
  >
    <div className="bg-white p-2 rounded w-10/12 max-h-[calc(100vh-180px)] ">
      <div className="flex items-start justify-between px-5 py-2  rounded-t">
        <h3 className="text-base 2xl:text-xl capitalize font-semibold">
          {data?.vendorDetails?.vendor_name + " view" || "Vendor View"}
        </h3>
        <span
          className="h-6 w-6 text-2xl block cursor-pointer"
          onClick={onClose}
        >
            <CloseIcon/>
        </span>
      </div>
      <div className="overflow-auto max-h-[calc(100vh-200px)]">
        <div>
          <div className="my-3 text-left">
            <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Vender Name
            </p>
            <p className="text-xs text-[#6E6985] font-semibold text-main-title bg-[#FDFAFF] py-3 pl-8 capitalize">
              {data?.vendorDetails?.vendor_name || "-"}
            </p>
          </div>
          <div className="my-3 text-left">
            <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Vender Type
            </p>
            <p className="text-xs text-[#6E6985] font-semibold text-main-title bg-[#FDFAFF] py-3 pl-8 capitalize">
              {data?.vendorDetails?.vendor_type || "-"}
            </p>
          </div>
          <div className="my-3 text-left">
            <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              OnBoard Date
            </p>
            <p className="text-xs text-[#6E6985] font-semibold text-main-title bg-[#FDFAFF] py-3 pl-8 capitalize">
              {(data?.on_board_date !== "None" &&
                data?.on_board_date !== "" &&
                NuDateFormat({
                  value: data?.on_board_date,
                  format: "DD-MMM-yyyy",
                })) ||
                "-"}
            </p>
          </div>

          <div className="my-3 text-left">
            <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
             Attachments
            </p>
            <div className=" w-full flex flex-wrap">
              {data?.attachments &&
                data?.attachments.map((i) => {
                  return (
                    <div className=" m-1">
                      <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ViewVendor